document.querySelector("#navbar-btn").onclick = function (e) {
  this.classList.toggle("change");
  document.querySelector("nav.menu").classList.toggle("active");
};

window.showRegister = (scroll = false) => {
  if (scroll) scrollToTop();
  if (event) event.preventDefault();
  document.querySelector("body").classList.add("show-register");
};

window.scrollToTop = (scrollDuration = 200) => {
  var scrollStep = -window.scrollY / (scrollDuration / 15),
    scrollInterval = setInterval(function () {
      if (window.scrollY != 0) {
        window.scrollBy(0, scrollStep);
      } else clearInterval(scrollInterval);
    }, 15);
};

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
    document.getElementById("return-to-top").classList.add("active");
  } else {
    document.getElementById("return-to-top").classList.remove("active");
  }
}

// register show hide
// let loginForm = document.querySelector('#loginForm');
// let registerForm = document.querySelector('#registerForm');
// document.querySelector('#hideLogin').addEventListener('click', function() {
//   event.preventDefault();
//   loginForm.style.display = 'none';
//   registerForm.style.display = 'block'

//   registerForm.classList.add('formClass')
//   loginForm.classList.remove('formClass')
// })

// document.querySelector('#hideRegister').addEventListener('click', function() {
//   event.preventDefault();
//   loginForm.style.display = 'block';
//   registerForm.style.display = 'none'

//   registerForm.classList.remove('formClass')
//   loginForm.classList.add('formClass')
// })
